// extracted by mini-css-extract-plugin
export default {"title":"TextBlock-module__title--SjzQF","toppings":"TextBlock-module__toppings--VwY8k"};